import HTTP from '../libs/HTTP';

export interface IAdminRoleInfo {
    roleId: number;
    roleName: string;
}

class AdminRoleService extends HTTP {
    async getAdminRole() {
        const response = await this.get('/adminRole', {});
        if (response && response.data) {
            return response.data;
        } else {
            return null;
        }
    }
}

export default new AdminRoleService();
